"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SvgIcon.default;
  }
});

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/SvgIcon/index.js
 ** module id = 196
 ** module chunks = 0
 **/